import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { AuctionsService } from 'src/app/features/rooms/core/service/auctions.service';

@Component({
  selector: 'app-change-status',
  templateUrl: './change-status.component.html',
  styleUrls: ['./change-status.component.css']
})
export class ChangeStatusComponent implements OnInit {
  loading = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ChangeStatusComponent>,
    public _config: ConfigService,
    private _auctions: AuctionsService,
  ) { }

  ngOnInit() {
  }
  confirm() {
    this.loading = true;

    const url = !this.data.data.is_published ? 'admin/auction/auctions/publish/' : 'admin/auction/auctions/unpublish/';
    this._auctions.changeStatusAuction(url, this.data.data.auctionId).subscribe({
      next: (data: any) => {
        this._config.toastrService.success(data.message);
        this.dialogRef.close('success');
      }, error: (error: any) => {
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);

        // });
        this._config.showErrors(error);
        this.dialogRef.close();
      }
    });
    // this.dialogRef.close('success');
  }
}
